// import React from "react";
// import { Typography, Box } from "@mui/material";

// export default function Scheduling() {
//   return (
//     <Box>
//       <Typography variant="h4" gutterBottom>
//         Scheduling
//       </Typography>
//       <Typography variant="body1">
//         Adjust application and admin settings.
//       </Typography>
//     </Box>
//   );
// }



import React, {useState} from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Tabs,
  Tab,
  Chip,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Button,
  useTheme
} from "@mui/material";
import {
  CalendarToday as CalendarIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CompletedIcon,
  Pending as PendingIcon,
  Person as PersonIcon,
} from "@mui/icons-material";

export default function Scheduling({ view = "calendar" }) {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(0);

  const upcomingJobs = [
    {
      id: 1,
      customer: "Sarah Johnson",
      cleaner: "Maria Garcia",
      service: "Deep Cleaning",
      date: "2024-03-23",
      time: "10:00 AM",
      duration: "4 hours",
      status: "Confirmed",
      address: "123 Main St, New York, NY"
    },
    {
      id: 2,
      customer: "Mike Brown",
      cleaner: "James Wilson",
      service: "Standard Cleaning",
      date: "2024-03-23",
      time: "2:00 PM",
      duration: "3 hours",
      status: "Confirmed",
      address: "456 Oak Ave, Los Angeles, CA"
    }
  ];

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Scheduling
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage and view all cleaning schedules and appointments
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Upcoming Jobs Today
              </Typography>
              <List>
                {upcomingJobs.map((job, index) => (
                  <Box key={job.id}>
                    <ListItem>
                      <ListItemIcon>
                        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                          <ScheduleIcon />
                        </Avatar>
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography fontWeight="600">
                              {job.service} for {job.customer}
                            </Typography>
                            <Chip 
                              label={job.status} 
                              size="small" 
                              color="success"
                              variant="outlined"
                            />
                          </Box>
                        }
                        secondary={
                          <Box sx={{ mt: 1 }}>
                            <Typography variant="body2">
                              <strong>Cleaner:</strong> {job.cleaner}
                            </Typography>
                            <Typography variant="body2">
                              <strong>Time:</strong> {job.time} • {job.duration}
                            </Typography>
                            <Typography variant="body2">
                              <strong>Address:</strong> {job.address}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                    {index < upcomingJobs.length - 1 && <Divider />}
                  </Box>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Quick Stats
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>Today's Jobs</Typography>
                  <Typography fontWeight="600">8</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>Completed</Typography>
                  <Typography fontWeight="600" color="success.main">5</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>Pending</Typography>
                  <Typography fontWeight="600" color="warning.main">3</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>Available Cleaners</Typography>
                  <Typography fontWeight="600" color="primary.main">12</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Card sx={{ mt: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Quick Actions
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Button variant="contained" fullWidth>
                  Schedule New Job
                </Button>
                <Button variant="outlined" fullWidth>
                  View Calendar
                </Button>
                <Button variant="outlined" fullWidth>
                  Assign Cleaner
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}